// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_320","toggleWrap":"styles_toggleWrap__1Ts6e","content":"styles_content__2rE3u","selectAreaCode":"styles_selectAreaCode__r7DX9"};